import { WebStorageStateStore } from 'oidc-client-ts';

const redirectPath = '/auth/oidc/callback';
const origin = window.location.origin;
const oidcStorage = window.localStorage;
const keycloakUrl = import.meta.env.VITE_APP_KEYCLOAK_URL || import.meta.env.VITE_KEYCLOAK_URL;
const keycloakRealm = import.meta.env.VITE_APP_KEYCLOAK_REALM || import.meta.env.VITE_KEYCLOAK_REALM;
const keycloakClientId =
  import.meta.env.VITE_APP_KEYCLOAK_CLIENT_ID ||
  import.meta.env.VITE_KEYCLOAK_CLIENT_ID ||
  'spryboard-spa';

const normalizePath = (path: string) => path.replace(/\/+$/, '') || '/';

const getPostLoginRedirect = () => {
  try {
    const saved = window.sessionStorage.getItem('post_login_redirect');
    if (saved) {
      window.sessionStorage.removeItem('post_login_redirect');
      try {
        const resolved = new URL(saved, origin);
        if (
          resolved.origin === origin &&
          normalizePath(resolved.pathname) !== redirectPath
        ) {
          return resolved.href;
        }
      } catch {
        // invalid URL — fall through to '/'
      }
    }
  } catch {
    // Ignore storage failures and fall back to root.
  }
  return '/';
};

const oidcConfig = {
  authority: `${keycloakUrl}/realms/${keycloakRealm}`,
  client_id: keycloakClientId,
  redirect_uri: `${origin}${redirectPath}`,
  post_logout_redirect_uri: origin,
  response_type: 'code',
  scope: 'openid profile email',
  loadUserInfo: true,
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: oidcStorage }),
  stateStore: new WebStorageStateStore({ store: oidcStorage }),
  useRefreshTokens: true,
  onSigninCallback: () => {
    // During add-new-account flow the library sets this flag and handles its
    // own return navigation via spry_return_url. If we redirect here we
    // override that and cause an extra reload loop.
    if (window.localStorage.getItem('spry_add_account_in_progress') === 'true') {
      try {
        window.localStorage.removeItem('spry:login-in-progress');
        window.localStorage.setItem('spry:last-callback', String(Date.now()));
        window.localStorage.setItem('spry:last-callback-success', 'true');
        window.sessionStorage.removeItem('spry:auth-error');
      } catch {
        // ignore storage errors
      }
      return; // SpryAuthProvider will navigate back via spry_return_url
    }

    try {
      window.localStorage.removeItem('spry:login-in-progress');
      window.localStorage.setItem('spry:last-callback', String(Date.now()));
      window.localStorage.setItem('spry:last-callback-success', 'true');
      window.sessionStorage.removeItem('spry:auth-error');
    } catch {
      // ignore storage errors
    }

    window.location.replace(getPostLoginRedirect());
  },
};

export default oidcConfig;
